'use client';

import { RialBlue } from '@/assets/icon/RialBlue';
import { welcomeNavigationTabs } from '@/lib/constants/navigationTabs';
import { usePathname, useRouter } from 'next/navigation';
import { useState } from 'react';
import { Button } from '../ui/button';
import { PopoverComponent, PopoverContent, PopoverTrigger } from '../ui/popover';
import { WelcomeNavbarDropdown } from './WelcomeNavbarDropdown';

export function WelcomeNavbar() {
  const [openPopover, setOpenPopover] = useState<string | null>(null);
  const router = useRouter();
  const pathname = usePathname();

  const isActiveTab = (href: string) => {
    return pathname === href;
  };

  const isActiveSubTab = (href: string) => {
    return pathname === href;
  };

  return (
    <nav className="fixed h-24 px-4 md:px-16 py-4 bg-white flex justify-between items-center z-50 w-full left-0 right-0">
      <RialBlue
        className="w-28 h-14 fill-blue-900 cursor-pointer hover:fill-blue-950 transition-colors duration-300"
        onClick={() => router.push('/')}
      />

      <div className="flex items-center gap-8">
        {welcomeNavigationTabs.map((tab) => (
          <div key={tab.label} className="hidden lg:block relative">
            {tab.subItems ? (
              <PopoverComponent
                open={openPopover === tab.label}
                onOpenChange={(open) => setOpenPopover(open ? tab.label : null)}
              >
                <PopoverTrigger asChild>
                  <button
                    className={`leading-normal cursor-pointer transition-colors duration-300 py-2 ${
                      isActiveTab(tab.href || '')
                        ? 'text-blue-950 font-semibold text-lg'
                        : 'text-blue-800 hover:text-blue-950'
                    }`}
                    onMouseEnter={() => setOpenPopover(tab.label)}
                    onClick={() => router.push(tab.href || '')}
                  >
                    {tab.label}
                  </button>
                </PopoverTrigger>
                <PopoverContent
                  className="w-auto p-0 mt-2 bg-white"
                  onMouseEnter={() => setOpenPopover(tab.label)}
                  onMouseLeave={() => setOpenPopover(null)}
                >
                  <div className="flex flex-col gap-2 p-2 min-w-[200px]">
                    {tab.subItems.map((subItem) => (
                      <a
                        key={subItem.label}
                        href={subItem.href}
                        className={`leading-normal cursor-pointer transition-colors duration-300 px-3 py-2 rounded-md ${
                          isActiveSubTab(subItem.href)
                            ? 'text-blue-950 font-semibold bg-blue-50'
                            : 'text-blue-800 hover:text-blue-950 hover:bg-blue-100'
                        }`}
                      >
                        {subItem.label}
                      </a>
                    ))}
                  </div>
                </PopoverContent>
              </PopoverComponent>
            ) : (
              <a
                className={`leading-normal cursor-pointer transition-colors duration-300 ${
                  isActiveTab(tab.href || '')
                    ? 'text-blue-950 font-semibold'
                    : 'text-blue-800 hover:text-blue-950'
                }`}
                href={tab.href}
              >
                {tab.label}
              </a>
            )}
          </div>
        ))}
      </div>

      <div className="flex items-center gap-4">
        <Button
          variant="primaryClear"
          className="hidden md:block"
          onClick={() => router.push('/auth/login')}
        >
          Iniciar sesión
        </Button>
        <div className="lg:hidden">
          <WelcomeNavbarDropdown />
        </div>
      </div>
    </nav>
  );
}
